import React from 'react';

type Props = {
  /** Заголовок слева */
  title: React.ReactNode;
  /** Блок справа (иконки/кнопки) */
  addButton?: React.ReactNode;
  /** НОВОЕ: центральный блок (табы / свитчер) */
  center?: React.ReactNode;
};

// Раскладка вынесена в App.css (`.page_header`), а не оставлена инлайном:
// на узком экране зоны должны перестраиваться в две строки, а медиа-запрос
// инлайн-стиль перебить не может — он всегда специфичнее.
// Обёртка `.page_header_box` — контейнер для @container в App.css: шапка с
// переключателем перестраивается по своей ширине, а не по ширине окна.
const ProductHeader: React.FC<Props> = ({ title, addButton, center }) => {
  return (
    <div className="page_header_box">
      <div className={center ? 'page_header page_header--center' : 'page_header'}>
        {/* слева: заголовок */}
        <div className="page_header__title">
          {typeof title === 'string' ? <h2 style={{ margin: 0 }}>{title}</h2> : title}
        </div>

        {/* центр: свитчер */}
        <div className="page_header__center">
          {center ?? null}
        </div>

        {/* справа: действия */}
        <div className="page_header__actions">{addButton}</div>
      </div>
    </div>
  );
};

export default ProductHeader;
